import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import toast from 'react-hot-toast';
import './Login.css';

export default function Login() {
  const [form, setForm] = useState({ usuario: '', senha: '' });
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState({ empresa_nome: 'Atendimento', empresa_logo_url: null });
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/config').then(({ data }) => setConfig(data)).catch(() => {});
  }, []);

  // Auto-login via query params (Electron app)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('autoLogin') === '1') {
      const u = params.get('u');
      const p = params.get('p');
      if (u && p) {
        setLoading(true);
        login(u, p).then(() => navigate('/')).catch(() => {
          toast.error('Credenciais salvas invalidas. Configure novamente.');
          setLoading(false);
        });
      }
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.usuario, form.senha);
      navigate('/');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Usuário ou senha incorretos');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          {config.empresa_logo_url
            ? <img src={config.empresa_logo_url} alt="Logo" />
            : <div className="login-logo-icon">💬</div>
          }
          <div>
            <h1>{config.empresa_nome || 'Atendimento'}</h1>
            <p>Central de Atendimento WhatsApp</p>
          </div>
        </div>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="field">
            <label>Usuário</label>
            <input type="text" value={form.usuario}
              onChange={e => setForm(f => ({ ...f, usuario: e.target.value }))}
              placeholder="seu.usuario" autoFocus required />
          </div>
          <div className="field">
            <label>Senha</label>
            <input type="password" value={form.senha}
              onChange={e => setForm(f => ({ ...f, senha: e.target.value }))}
              placeholder="••••••••" required />
          </div>
          <button type="submit" className="btn-login" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
